<template>
  <div class="roadMap">
    <MyHeader activeIndex="5"></MyHeader>
    <div class="main">
      <div class="part1">
        <div class="box">
          <div class="words">
            <h1>{{ $t("roadmap") }}</h1>
            <p v-html="$t('roadmapMsg')"></p>
          </div>
          <div class="img">
            <img src="../../static/roadMap.svg" alt />
          </div>
        </div>
      </div>
      <!-- <div class="part2">
        <div class="come-soon">{{ $t('comingSoon') }}</div>
      </div> -->

      <div class="progressBar">
        <div class="barTitle">
          <!-- <img class="logo" src="../assets/161770454.jpg" alt="" /> -->
          <div class="titiName">
            <div>Road Map</div>
            <div>2021-2022</div>
          </div>
        </div>
        <div class="speedProgress">
          <div class="textCont">
            <div class="text">
              <div>Development of Mining Client COS-v2.0</div>
              <div>Multi-chain token exchange function plan and strategy</div>
            </div>
            <div class="lineBox">
              <div class="circular two">
                Qtr 1 <br />
                2021
              </div>
              <div class="solidBor"></div>
            </div>
            <div class="text"></div>
          </div>
          <div class="textCont">
            <div class="text"></div>
            <div class="lineBox">
              <div class="circular two">
                Qtr 2 <br />
                2021
              </div>
              <div class="solidBor"></div>
            </div>
            <div class="text">
              <div>COS-v2.0 Ready for Beta Testing</div>
              <div>
                Multi-chain token exchange function capability
                testing：ERC20-TRC20
              </div>
              <div>
                Creation and internal testing of new Sharder Community Forum
              </div>
            </div>
          </div>
          <div class="textCont">
            <div class="text">
              <div>Sharder Contract Upgrade Version 3.0</div>
              <div>
                Release Mining Client COS-v2.0 
              </div>
              <div>
                Reset Testnet & Commence hub beta testing
              </div>
              <div>Sharder Test Network open access</div>
              <div></div>
            </div>
            <div class="lineBox">
              <div class="circular two">
                Qtr 3 <br />
                2021
              </div>
              <div class="solidBor"></div>
            </div>
            <div class="text"></div>
          </div>
          <div class="textCont">
            <div class="text"></div>
            <div class="lineBox">
              <div class="circular two">
                Qtr 4 <br />
                2021
              </div>
              <div class="solidBor"></div>

              <div class="circular active">
                Qtr 1&2 <br />
                2022
              </div>
            </div>
            <div class="text">
              <div>Test & refine network for stability</div>
              <div>Release Mining Client COS-v2.1</div>
              <div>
                Multi-chain token exchange function capability testing：Huobi -
                HECO + Binance
                <div style="margin-top: 0">Chain - BSC</div>
              </div>
            </div>
          </div>
        </div>
        <div class="blackBackText">
          <div class="text">Prepare for live Mainnet launch</div>
          <div class="text">Test & refine Mainnet stability</div>
          <div class="text">
            Begin collaborations with other chains and networks
          </div>
          <div class="text">Network open for developers to build DApp's on</div>
          <div class="text">
            Market authentication, validation and secure storage <br />
            <span class="active"
              >functions to business and corporate entities</span
            >
          </div>
        </div>
        <div class="whiteBackText">
          <div class="text">
            Marketing strategy, brand refinement, brand awareness, hub, box,
            mining and staking preparations along with other exciting
            developments will be implemented 'in parallel' to development of the
            technology.
          </div>
          <div class="text active">
            All updates, news and alerts will be broadcast to the community via
            telegram and other key official Sharder channels.
          </div>
        </div>
      </div>
      <div>
        <!--<div class="part2">-->
        <!--<div class="box2">-->
        <!--<div class="left">-->
        <!--<div class="leftItem">-->
        <!--<div class="item-title">-->
        <!--<span class="item-title-year">2018</span>-->
        <!--<span class="item-title-line"></span>-->
        <!--<span class="item-title-circular check"></span>-->
        <!--</div>-->
        <!--<div class="item-body">-->
        <!--<p>R&D of sharder chain ·</p>-->
        <!--<p>Technical and community whitepapers ·</p>-->
        <!--<p>GitHub open source ·</p>-->
        <!--<p>Incorporate Bean Cloud on Sharder chain ·</p>-->
        <!--<p>Provide E-Contracts & judicial storage and validation ·</p>-->
        <!--<p>Contracts stored on Sharder Alpha-Net ·</p>-->
        <!--<p>Develop off-chain storage ·</p>-->
        <!--<p>Integrate IPFS Protocol ·</p>-->
        <!--<p>Internal testing of Testnet ·</p>-->
        <!--<p>Develop hub prototype ·</p>-->
        <!--<p>Develop proof of stake mining consensus ·</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="leftItem">-->
        <!--<div class="item-title">-->
        <!--<span class="item-title-year">2020</span>-->
        <!--<span class="s">Q1</span>-->
        <!--<span class="item-title-line"></span>-->
        <!--<span class="item-title-circular check"></span>-->
        <!--</div>-->
        <!--<div class="item-body">-->
        <!--<p>Release hub client V0.2.0 ·</p>-->
        <!--<p>Reset Testnet & prepare for phase 2 of testing ·</p>-->
        <!--<p>Research and development based off results from Testnet ·</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="leftItem">-->
        <!--<div class="item-title">-->
        <!--<span class="item-title-year">2020</span>-->
        <!--<span class="s">Q3</span>-->
        <!--<span class="item-title-line"></span>-->
        <!--<span class="item-title-circular"></span>-->
        <!--</div>-->
        <!--<div class="item-body">-->
        <!--<p>Increase marketing of Sharder Network ·</p>-->
        <!--<p>Develop and test auto exchange of SS & SS-M ·</p>-->
        <!--<p>Proof of Credit consensus adjustment ·</p>-->
        <!--<p>Reduction of mining rewards ·</p>-->
        <!--<p>Expand user base of SignEase and international licensing ·</p>-->
        <!--<p>Develop ISLAND application ·</p>-->
        <!--<p>Hub sales reopen ·</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="line"></div>-->
        <!--<div class="right">-->
        <!--<div class="leftItem">-->
        <!--<div class="item-title">-->
        <!--<span class="item-title-circular check"></span>-->
        <!--<span class="item-title-line"></span>-->
        <!--<span class="item-title-year">2019</span>-->
        <!--</div>-->
        <!--<div class="item-body">-->
        <!--<p>· Public testing of Testnet</p>-->
        <!--<p>· Developed and released Hub Client Versions 0.1.5.</p>-->
        <!--<p>· Develop Proof of Credit and Distributed Proof of Stake Consenus</p>-->
        <!--<p>· Produce first batch of Sharder Hub micro nodes</p>-->
        <!--<p>· Create &amp; test Sharder Pools</p>-->
        <!--<p>· Enable hub activation and pool staking</p>-->
        <!--<p>· Develop Network Addresss Translation roles</p>-->
        <!--<p>· Develop box prototype as a multi role node</p>-->
        <!--<p>· Internal testing of box prototype</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="leftItem">-->
        <!--<div class="item-title">-->
        <!--<span class="item-title-circular check"></span>-->
        <!--<span class="s">Q2</span>-->
        <!--<span class="item-title-line"></span>-->
        <!--<span class="item-title-year">2020</span>-->
        <!--</div>-->
        <!--<div class="item-body">-->
        <!--<p>· Develop storage validation network</p>-->
        <!--<p>· Test off-chain storage & on-chain storage validation</p>-->
        <!--<p>· Develop and test SS burning</p>-->
        <!--<p>· Hire new marketing personal</p>-->
        <!--<p>· Release whitepaper V3</p>-->
        <!--<p>· Design and develop new website</p>-->
        <!--<p>· UI / UX of ISLAND Application</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="leftItem">-->
        <!--<div class="item-title">-->
        <!--<span class="item-title-circular"></span>-->
        <!--<span class="s">Q4</span>-->
        <!--<span class="item-title-line"></span>-->
        <!--<span class="item-title-year">2020</span>-->
        <!--</div>-->
        <!--<div class="item-body">-->
        <!--<p>· Mainnet launch</p>-->
        <!--<p>· ISLAND launch</p>-->
        <!--<p>· Hub client v1.0</p>-->
        <!--<p>· Box Announcement</p>-->
        <!--<p>· New exchange listing</p>-->
        <!--<p>· Research for 'Block Drop' application</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </div>
    <MyFooter></MyFooter>
  </div>
</template>

<script>
import MyHeader from "@/views/components/Header.vue";
import MyFooter from "@/views/components/Footer.vue";
export default {
  name: "roadMap",
  components: { MyHeader, MyFooter },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped>
@media screen and (min-width: 768px) {
  .progressBar {
    width: 100%;
    background: #080604;
    padding: 40px 0;
    .whiteBackText {
      background-color: white;
      width: 80%;
      margin: 0 auto;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 5px;
      margin-top: 40px;
      .text {
        width: 50%;
        margin: 0 auto;
        text-align: center;
        color: #000;
        font-size: 24px;
      }
      .text.active {
        margin-top: 30px;
      }
    }
    .blackBackText {
      width: 100%;
      margin-top: 80px;
      font-weight: 300;
      .text {
        text-align: center;
        color: #fff;
        font-size: 24px;
        margin-top: 30px;
        .active {
          margin-top: 10px;
        }
      }
    }
    .speedProgress {
      width: 80%;
      margin: 0 auto;
      .textCont {
        display: flex;
        justify-content: space-between;
        min-height: 200px;
        .lineBox {
          width: 20%;
          position: relative;
          display: flex;
          justify-content: center;
          .circular {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            background-color: #fff;
            position: absolute;
            left: calc(50% - 45px);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            font-weight: 500;
          }
          .circular.two {
            top: -45px;
          }
          .circular.active {
            bottom: -45px;
          }
          .solidBor {
            width: 5px;
            margin-left: 5px;
            border-right: 5px dashed #fff;
          }
        }
        .text {
          text-align: left;
          width: 40%;
          font-size: 24px;
          color: #fff;
          div {
            margin-top: 20px;
          }
        }
      }
    }
    .barTitle {
      width: 80%;
      margin: 0 auto 120px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      .logo {
        width: 14rem;
        height: 14rem;
      }
      .titiName {
        font-weight: bold;
        color: #fff;
        font-size: 4rem;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .progressBar {
    width: 100%;
    background: #080604;

    padding: 4rem 0;
    .whiteBackText {
      background-color: white;
      width: 90%;
      margin: 0 auto;
      padding: .4rem;
      box-sizing: border-box;
      border-radius: .05rem;
      margin-top:2rem;
      .text {
        // width: 50%;
        margin: 0 auto;
        text-align: center;
        color: #000;
        font-size: 1rem;
      }
      .text.active {
        margin-top: 1rem;
      }
    }
    .blackBackText {
      width: 100%;
      margin-top: 6rem;
      font-weight: 300;
      .text {
        text-align: center;
        color: #fff;
        font-size: 1.4rem;
        margin-top: 1rem;
        .active {
          margin-top: .1rem;
        }
      }
    }
    .speedProgress {
      width: 96%;
      margin: 0 auto;
      .textCont {
        display: flex;
        justify-content: space-between;
        min-height: 4rem;
        .lineBox {
          width: 20%;
          position: relative;
          display: flex;
          justify-content: center;
          .circular {
            width: 5rem;
            height: 5rem;
            border-radius: 50%;
            background-color: #fff;
            position: absolute;
            left: calc(50% - 2.5rem);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.4rem;
            font-weight: 500;
          }
          .circular.two {
            top: -2.5rem;
          }
          .circular.active {
            bottom: -2.5rem;
          }
          .solidBor {
            width:.1rem;
            margin-left: .1rem;
            border-right: .1rem dashed #fff;
          }
        }
        .text {
          text-align: left;
          width: 40%;
          font-size: 1.2rem;
          color: #fff;
          margin-top: -1rem;
          div {
            margin-bottom: 1.2rem;
          }
        }
      }
    }

    .barTitle {
      width: 80%;
      margin: 0 auto 6rem;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      .logo {
        width: 8rem;
        height: 8rem;
      }
      .titiName {
        font-weight: bold;
        color: #fff;
        font-size: 2rem;
      }
    }
  }

  .part2 {
    padding: 5rem 0;
  }
  .part2 .box2 {
    width: 90%;
  }
  .part1 {
    padding: 4rem 0;
  }
  .part2 .box2 .line {
    border-left: 0.2rem dashed #00ccff;
    height: 85rem;
  }

  .box2 .left .leftItem .item-title .item-title-year {
    font-size: 2rem;
    font-weight: bold;
    color: #000;
    vertical-align: middle;
    margin-right: 0.5rem;
  }
  .box2 .left .leftItem .item-title .item-title-line {
    background-color: #00157b;
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    width: 3rem;
    height: 0.2rem;
    display: inline-block;
    position: relative;
    left: 1.2rem;
  }

  @mixin circular {
    padding: 1rem 1rem;
    border: 0.1rem solid #00157b;
    border-radius: 100%;
    background-color: #fff;
    position: relative;
  }

  .box2 .left .leftItem .item-title .item-title-circular {
    left: 1.2rem;
    @include circular;
  }

  .box2 .right .leftItem .item-title .item-title-year {
    font-size: 2rem;
    font-weight: bold;
    color: #000;
    vertical-align: middle;
    margin-right: 0.5rem;
  }
  .box2 .right .leftItem .item-title .item-title-line {
    background-color: #00157b;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    width: 3rem;
    height: 0.2rem;
    display: inline-block;
    position: relative;
    right: 1.2rem;
  }
  .box2 .right .leftItem .item-title .item-title-circular {
    right: 1.2rem;
    @include circular;
  }
  .box2 .right .leftItem .item-body {
    padding-left: 1.5rem;
  }
  .box2 .left .leftItem .item-body {
    padding-right: 1rem;
  }
  .box2 .left .leftItem .item-title .s {
    right: 2rem;
    font-size: 12px;
  }
  .box2 .right .leftItem .item-title .s {
    left: 2rem;
  }
}

.come-soon {
  font-size: 2em;
}

.part1 {
  padding: 8rem 0;
  background-color: #f5f5f5;
}
.part1 .box {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.part1 .box .words {
  text-align: left;
}
.part1 .box .words h1 {
  font-size: 5rem;
  display: inline-block;
  margin: 1rem 0;
}
.part1 .box .words p {
  color: #b3b3b3;
  font-size: 2rem;
  line-height: 3rem;
}
.part2 {
  padding: 8rem 0;
  background-color: #fff;
}
.part2 .box2 {
  width: 60%;
  margin: 0 auto;
  text-align: center;
  position: relative;
  display: flex;
}
.box2 .left {
  width: calc(50% - 0.5rem);
  text-align: right;
}
.box2 .right {
  width: 50%;
  text-align: left;
}
.box2 .left .leftItem {
  margin-bottom: 2rem;
}
.box2 .left .leftItem .item-title {
  position: relative;
}
.box2 .left .leftItem .item-title .s {
  position: absolute;
  right: 4rem;
  top: 0;
  font-weight: bold;
  color: #336699;
}
.box2 .left .leftItem .item-body {
  padding-right: 2rem;
}
.box2 .left .leftItem .item-title .item-title-year {
  font-size: 3rem;
  font-weight: bold;
  color: #000;
  vertical-align: middle;
  margin-right: 0.5rem;
}
.box2 .left .leftItem .item-title .item-title-line {
  background-color: #00157b;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  width: 5rem;
  height: 0.5rem;
  display: inline-block;
  position: relative;
  left: 1.4rem;
}
.box2 .left .leftItem .item-title .item-title-circular {
  display: inline-block;
  padding: 1rem 1rem;
  border: 0.2rem solid #00157b;
  border-radius: 100%;
  background-color: #fff;
  position: relative;
  top: 1rem;
  left: 1.4rem;
}
.box2 .right .leftItem:first-child {
  margin-top: 8rem;
}
.box2 .right .leftItem {
  margin-bottom: 2rem;
}
.box2 .right .leftItem .item-title {
  position: relative;
}
.box2 .right .leftItem .item-title .s {
  position: absolute;
  top: 0;
  left: 4rem;
  font-weight: bold;
  color: #336699;
}
.box2 .right .leftItem .item-body {
  padding-left: 3rem;
}
.box2 .right .leftItem .item-title .item-title-year {
  font-size: 3rem;
  font-weight: bold;
  color: #000;
  vertical-align: middle;
  margin-right: 0.5rem;
}
.box2 .right .leftItem .item-title .item-title-line {
  background-color: #00157b;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  width: 5rem;
  height: 0.5rem;
  display: inline-block;
  position: relative;
  right: 1.4rem;
}
.box2 .right .leftItem .item-title .item-title-circular {
  display: inline-block;
  padding: 1rem 1rem;
  border: 0.2rem solid #00157b;
  border-radius: 100%;
  background-color: #fff;
  position: relative;
  top: 1rem;
  right: 1.4rem;
}

.item-title-circular.check {
  background: url("../../static/icon-check.svg") center no-repeat;
  background-size: 24px;
}

.part2 .box2 .line {
  border-left: 0.5rem dashed #00ccff;
  height: 70rem;
  display: inline-block;
}
</style>
